import React from "react";
import { Volume2, VolumeX, Volume1 } from "lucide-react";

/** Small pill used across the dashboard header + tile footer. */
export function StatChip({ label, value, tone = "default" }) {
  const toneCls = {
    default: "text-foreground/80",
    live: "text-rose-400 dark:text-rose-400",
    ok: "text-emerald-500 dark:text-emerald-400",
    warn: "text-amber-500 dark:text-amber-400",
  }[tone];
  return (
    <div className="flex items-center gap-1.5 font-mono text-[10px]">
      <span className="text-muted-foreground uppercase tracking-widest">{label}</span>
      <span className={toneCls}>{value}</span>
    </div>
  );
}

export function AudioControl({ soloed, volume, onToggleSolo, onVolumeChange, testId, inline = false }) {
  const Icon = !soloed ? VolumeX : volume < 0.05 ? VolumeX : volume < 0.6 ? Volume1 : Volume2;
  if (inline) {
    return (
      <div className="flex items-center gap-2 rounded-sm bg-card border border-border px-2 py-1.5">
        <button
          type="button"
          onClick={onToggleSolo}
          data-testid={testId ? `${testId}-toggle` : undefined}
          aria-label={soloed ? "Mute this channel" : "Solo this channel's audio"}
          className={`p-1 rounded-sm hover:bg-accent ${soloed ? "text-emerald-500 dark:text-emerald-400" : "text-foreground/80"}`}
        >
          <Icon className="w-4 h-4" strokeWidth={2} />
        </button>
        <input
          type="range" min="0" max="1" step="0.05" value={volume}
          onChange={(e) => onVolumeChange(Number(e.target.value))}
          data-testid={testId ? `${testId}-volume` : undefined}
          aria-label="Volume"
          className="flex-1 accent-emerald-500 cursor-pointer"
        />
        <span className="font-mono text-[10px] text-muted-foreground w-8 text-right">
          {Math.round(volume * 100)}%
        </span>
      </div>
    );
  }
  return (
    <div
      className={`absolute top-2 right-16 z-20 flex items-center gap-1 rounded-sm bg-black/70 border border-white/20 pl-1.5 pr-1 py-0.5 transition-opacity ${
        soloed ? "opacity-100" : "opacity-0 group-hover/tile:opacity-100"
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        onClick={onToggleSolo}
        data-testid={testId ? `${testId}-toggle` : undefined}
        aria-label={soloed ? "Mute this channel" : "Solo this channel's audio"}
        className={`p-0.5 rounded-sm hover:bg-white/10 ${soloed ? "text-emerald-400" : "text-zinc-200"}`}
      >
        <Icon className="w-3.5 h-3.5" strokeWidth={2} />
      </button>
      {soloed && (
        <input
          type="range" min="0" max="1" step="0.05" value={volume}
          onChange={(e) => onVolumeChange(Number(e.target.value))}
          data-testid={testId ? `${testId}-volume` : undefined}
          aria-label="Volume"
          className="w-16 accent-emerald-500 cursor-pointer"
        />
      )}
    </div>
  );
}
